const GET_DEFINITIONS_LINKS = 'GET_DEFINITIONS_LINKS';
const SET_LINK = 'SET_LINK';
const SET_CLASSES = 'SET_CLASSES';
const SET_EVENTS = 'SET_EVENTS';
const GET_CLASSES = 'GET_CLASSES';
const GET_ENDURANCE_EVENTS = 'GET_ENDURANCE_EVENTS';
const GET_EVENTS = 'GET_EVENTS';
const GET_EVENTS_BY_NSHORT = 'GET_EVENTS_BY_NSHORT';
const FETCH_IEVENT_NCLASS_BY_SHORT = 'FETCH_IEVENT_NCLASS_BY_SHORT';

export default {
	GET_DEFINITIONS_LINKS,
	SET_LINK,
	GET_CLASSES,
	GET_ENDURANCE_EVENTS,
	SET_CLASSES,
	SET_EVENTS,
	GET_EVENTS,
	GET_EVENTS_BY_NSHORT,
	FETCH_IEVENT_NCLASS_BY_SHORT,
};
